// Import model
import { UpdateDoorRequest } from '../models/UpdateDoorRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { UpdatePointRequest } from '../models/UpdatePointRequest';

// Import dependency serializers (for complex types)
import { UpdatePointRequestSerializer } from './UpdatePointRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateDoorRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateDoorRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateDoorRequest instance
   */
  static deserialize(json: string): UpdateDoorRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateDoorRequest instance
   */
  static fromObject(obj: any): UpdateDoorRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateDoorRequest');
    }


    const instance: UpdateDoorRequest = {
      addTransition: obj['addTransition'] as boolean | undefined,
      name: obj['name'] as string | undefined,
      trimDoor: obj['trimDoor'] as boolean | undefined,
      wallIndex: obj['wallIndex'] as number | undefined,
      widthUom: obj['widthUOM'] as string | undefined,
      width: obj['width'] as number | undefined,
      isOpening: obj['isOpening'] as boolean | undefined,
      offset: obj['offset'] as number | undefined,
      shape: obj['shape'] ? (obj['shape'] as any[]).map((item: any) =>
        UpdatePointRequestSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateDoorRequest instances
   */
  static deserializeArray(json: string): UpdateDoorRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateDoorRequest instance to a JSON string
   */
  static serialize(instance: UpdateDoorRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateDoorRequest instance to a plain object
   */
  static toObject(instance: UpdateDoorRequest): any {
    return {
      'addTransition': instance.addTransition,
      'name': instance.name,
      'trimDoor': instance.trimDoor,
      'wallIndex': instance.wallIndex,
      'widthUOM': instance.widthUom,
      'width': instance.width,
      'isOpening': instance.isOpening,
      'offset': instance.offset,
      'shape': instance.shape?.map((item: any) =>
        UpdatePointRequestSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of UpdateDoorRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateDoorRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
